import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      {/* Hero Section */}
      <section className="legal-hero parallax-bg">
        <div className="hero-background">
          <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" alt="Privacy Policy" />
        </div>
        <div className="parallax-overlay"></div>
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="hero-content"
            >
              <div className="breadcrumb">
                <Link to="/">Home</Link>
                <span>/</span>
                <span>Privacy Policy</span>
              </div>
              <h1>Privacy Policy</h1>
              <p>Your privacy is important to us. Learn how we collect, use, and protect your information.</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-content section">
        <div className="container-wide">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="legal-document"
            >
              <div className="document-header">
                <h2>Privacy Policy for Efficient Group</h2>
                <p className="last-updated">Last updated: December 2024</p>
              </div>

              <div className="document-content">
                <section className="legal-section">
                  <h3>1. Information We Collect</h3>
                  <p>We collect information you provide directly to us, such as when you:</p>
                  <ul>
                    <li>Fill out contact forms or request quotes</li>
                    <li>Subscribe to our newsletter or communications</li>
                    <li>Participate in training programs or consultations</li>
                    <li>Contact us for support or services</li>
                  </ul>
                  <p>This may include your name, email address, phone number, company information, and project details.</p>
                </section>

                <section className="legal-section">
                  <h3>2. How We Use Your Information</h3>
                  <p>We use the information we collect to:</p>
                  <ul>
                    <li>Provide and improve our facilities management services</li>
                    <li>Respond to your inquiries and provide customer support</li>
                    <li>Send you service updates and promotional communications</li>
                    <li>Analyze usage patterns to enhance our website and services</li>
                    <li>Comply with legal obligations and protect our rights</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>3. Information Sharing</h3>
                  <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except:</p>
                  <ul>
                    <li>To trusted service providers who assist in operating our website and conducting business</li>
                    <li>When required by law or to protect our rights and safety</li>
                    <li>In connection with a business transfer or merger</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>4. Data Security</h3>
                  <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>
                </section>

                <section className="legal-section">
                  <h3>5. Cookies and Tracking</h3>
                  <p>Our website uses cookies to enhance your browsing experience. You can control cookie settings through your browser preferences. For more details, please see our <Link to="/cookie-policy">Cookie Policy</Link>.</p>
                </section>

                <section className="legal-section">
                  <h3>6. Your Rights</h3>
                  <p>You have the right to:</p>
                  <ul>
                    <li>Access and update your personal information</li>
                    <li>Request deletion of your data</li>
                    <li>Opt-out of marketing communications</li>
                    <li>Request data portability</li>
                  </ul>
                </section>

                <section className="legal-section">
                  <h3>7. Third-Party Links</h3>
                  <p>Our website may contain links to third-party sites. We are not responsible for the privacy practices of these external sites and encourage you to review their privacy policies.</p>
                </section>

                <section className="legal-section">
                  <h3>8. Children's Privacy</h3>
                  <p>Our services are not directed to children under 13. We do not knowingly collect personal information from children under 13 years of age.</p>
                </section>

                <section className="legal-section">
                  <h3>9. Changes to This Policy</h3>
                  <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.</p>
                </section>

                <section className="legal-section">
                  <h3>10. Contact Us</h3>
                  <p>If you have any questions about this Privacy Policy, please contact us:</p>
                  <div className="contact-info">
                    <p><strong>Email:</strong> privacy@efficientgroupdubai.com</p>
                    <p><strong>Phone:</strong> +1 (555) 123-4567</p>
                    <p><strong>Address:</strong> 123 Business District, Dubai, UAE</p>
                  </div>
                </section>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;